(function () {
  'use strict';

  const getApiBaseUrl = () => {
    return (window.BIS_CONFIG && window.BIS_CONFIG.apiBaseUrl) || 'https://backinstock.fadecommerce.com';
  };

  async function apiHandler(endpoint, options = {}) {
    const url = `${getApiBaseUrl()}${endpoint}`;

    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  }

  let shopifyDomain = '';
  let variantId = '';

  const backInStockErrorMessage = document.getElementById('backInStockErrorMessage');
  const nameErrorMessage = document.getElementById('nameErrorMessage');
  const emailErrorMessage = document.getElementById('emailErrorMessage');
  const subscribeBtnText = document.getElementById('subscribeBtnText');
  const bisModel = document.getElementById('backInStockModel');
  const overlay = document.getElementById('backinstockOverlay');
  const notifyBtn = document.getElementById('notifyMeBtn');
  const popupForm = document.getElementById('backinstockPopupForm');
  const formCloseBtn = document.getElementById('backinstockFormCloseBtn');
  const form = document.getElementById('backinstockForm');
  const backInStockName = document.getElementById('backInStockName');
  const backInStockEmail = document.getElementById('backInStockEmail');
  const successPopup = document.getElementById('backinstockSuccessPopup');
  const successCloseBtn = document.getElementById('backinstockSuccessCloseBtn');
  const subscribeBtn = document.getElementById('subscribeBtn');
  const btnLoader = document.getElementById('btnLoader');

  if (!bisModel || !notifyBtn || !overlay || !popupForm || !form || !subscribeBtn) {
    return;
  }

  const safeSetDisplay = (element, displayStyle) => {
    if (element) {
      element.style.display = displayStyle;
    }
  };

  [overlay, popupForm, successPopup].forEach((el) => {
    if (el) {
      document.body.appendChild(el);
    }
  });

  if (typeof Shopify !== 'undefined' && Shopify.shop) {
    shopifyDomain = Shopify.shop;
  }

  if (backInStockName && nameErrorMessage) {
    backInStockName.addEventListener('input', function () {
      nameErrorMessage.style.display = 'none';
      nameErrorMessage.innerText = '';
    });
  }

  if (backInStockEmail && emailErrorMessage) {
    backInStockEmail.addEventListener('input', function () {
      emailErrorMessage.style.display = 'none';
      emailErrorMessage.innerText = '';
    });
  }

  function getQueryParameterByName(name) {
    const match = window.location.search.match(new RegExp('[?&]' + name + '=([^&]*)'));
    return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : null;
  }

  function getVariantID(productForm) {
    let finalSelectorValue = null;

    if (productForm && productForm.querySelector('[name="id"]')) {
      finalSelectorValue = productForm.querySelector('[name="id"]').value;
    } else {
      const globalSelector = document.querySelector('form [name="id"]');
      finalSelectorValue = globalSelector ? globalSelector.value : null;
    }

    if (!finalSelectorValue) {
      finalSelectorValue = getQueryParameterByName('variant');
    }

    return finalSelectorValue || '';
  }

  function handleVariantChange(currentVariantId) {
    const variant = (window.productVariants || []).find((v) => String(v.id) === String(currentVariantId));
    if (!variant || !bisModel) {
      return;
    }

    bisModel.style.display = variant.available ? 'none' : 'block';
  }

  async function subscribeProduct() {
    const name = backInStockName ? backInStockName.value.trim() : '';
    const emailAddress = backInStockEmail ? backInStockEmail.value.trim() : '';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let hasError = false;

    if (nameErrorMessage) {
      nameErrorMessage.style.display = 'none';
    }
    if (emailErrorMessage) {
      emailErrorMessage.style.display = 'none';
    }
    if (backInStockErrorMessage) {
      backInStockErrorMessage.style.display = 'none';
    }

    if (!name) {
      if (nameErrorMessage) {
        nameErrorMessage.style.display = 'block';
      }
      hasError = true;
    }

    if (!emailAddress || !emailRegex.test(emailAddress)) {
      if (emailErrorMessage) {
        emailErrorMessage.style.display = 'block';
      }
      hasError = true;
    }

    if (hasError) {
      safeSetDisplay(subscribeBtnText, 'block');
      safeSetDisplay(btnLoader, 'none');
      return;
    }

    try {
      const payload = {
        shopify_domain: shopifyDomain,
        name: name,
        email: emailAddress,
        variant_id: variantId,
      };

      const response = await apiHandler('/api/email-subscribe', {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      if (!response.status) {
        if (backInStockErrorMessage) {
          backInStockErrorMessage.style.display = 'block';
        }
        safeSetDisplay(subscribeBtnText, 'block');
        safeSetDisplay(btnLoader, 'none');
        return;
      }

      openSuccessPopup();
      safeSetDisplay(btnLoader, 'none');

      if (backInStockName) {
        backInStockName.value = '';
      }
      if (backInStockEmail) {
        backInStockEmail.value = '';
      }
    } catch (error) {
      console.error('Back in stock subscribe failed:', error);
      if (backInStockErrorMessage) {
        backInStockErrorMessage.style.display = 'block';
      }
      safeSetDisplay(subscribeBtnText, 'block');
      safeSetDisplay(btnLoader, 'none');
    }
  }

  function openFormPopup() {
    overlay.classList.add('active');
    popupForm.classList.add('active');
    successPopup.classList.remove('active');
    popupForm.setAttribute('aria-hidden', 'false');
    successPopup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
      if (backInStockName) {
        backInStockName.focus();
      }
    }, 200);
  }

  function subscribe() {
    safeSetDisplay(subscribeBtnText, 'none');
    safeSetDisplay(btnLoader, 'flex');
    subscribeProduct();
  }

  function closeAllPopups() {
    overlay.classList.remove('active');
    popupForm.classList.remove('active');
    successPopup.classList.remove('active');
    popupForm.setAttribute('aria-hidden', 'true');
    successPopup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function openSuccessPopup() {
    popupForm.classList.remove('active');
    successPopup.classList.add('active');
    popupForm.setAttribute('aria-hidden', 'true');
    successPopup.setAttribute('aria-hidden', 'false');

    setTimeout(() => {
      if (successCloseBtn) {
        successCloseBtn.click();
      }
    }, 1500);
  }

  notifyBtn.addEventListener('click', openFormPopup);
  overlay.addEventListener('click', closeAllPopups);

  if (formCloseBtn) {
    formCloseBtn.addEventListener('click', closeAllPopups);
  }
  if (successCloseBtn) {
    successCloseBtn.addEventListener('click', closeAllPopups);
  }

  subscribeBtn.addEventListener('click', subscribe);

  document.addEventListener('keydown', function (e) {
    if ((popupForm.classList.contains('active') || successPopup.classList.contains('active')) && e.key === 'Escape') {
      closeAllPopups();
    }

    if ((popupForm.classList.contains('active') || successPopup.classList.contains('active')) && e.key === 'Tab') {
      const focusables = Array.from(document.querySelectorAll('.backinstock-popup.active button, .backinstock-popup.active input'));
      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      }
    }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    subscribe();
  });

  window.addEventListener('load', () => {
    const formEl = document.querySelector('#backInStockModel')?.closest('form') || document.querySelector("form[action='/cart/add']");
    if (!formEl) {
      return;
    }

    variantId = getVariantID(formEl);
    handleVariantChange(variantId);
  });

  const variantSelectors = document.querySelectorAll(
    "[name='id'], .single-option-selector, .single-option-selector__radio, select[data-option], select[data-index], .product-single__variants, [name='option-1']"
  );

  variantSelectors.forEach((el) => {
    el.addEventListener('change', () => {
      const formEl = document.querySelector('#backInStockModel')?.closest('form') || document.querySelector("form[action='/cart/add']");
      if (!formEl) {
        return;
      }

      variantId = getVariantID(formEl);
      handleVariantChange(variantId);
    });
  });
})();
